(() => {
  const initializeMobileNavigation = () => {
    const bar = document.querySelector('.m-mobile-sticky-bar');
    if (!bar || bar.dataset.mobileNavReady === 'true') return;

    const mobileQuery = window.matchMedia('(max-width: 767px)');
    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    bar.dataset.mobileNavReady = 'true';

    const animateEntry = () => {
      if (!mobileQuery.matches || reduceMotionQuery.matches) return;

      let direction = '';
      try {
        direction = window.sessionStorage.getItem('abs-mobile-nav-direction') || '';
        window.sessionStorage.removeItem('abs-mobile-nav-direction');
      } catch (error) {
        direction = '';
      }

      const navigation = window.performance.getEntriesByType('navigation')[0];
      if (!direction && navigation && navigation.type === 'back_forward') direction = 'back';
      if (!direction) return;

      const className = direction === 'back'
        ? 'abs-mobile-page-entering-back'
        : 'abs-mobile-page-entering';

      document.body.classList.add(className);
      window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
        document.body.classList.remove(className);
      }));
    };

    animateEntry();

    const pageSurface = document.querySelector('#MainContent') || document.querySelector('main');
    const barItems = [...bar.querySelectorAll('.m-mobile-sticky-bar--item')];
    const swipeLinks = [...bar.querySelectorAll('a[href]')].filter((link) => {
      try {
        const url = new URL(link.href, window.location.href);
        return url.protocol === 'https:' || url.protocol === 'http:';
      } catch (error) {
        return false;
      }
    });

    const currentSwipeIndex = () => {
      const current = new URL(window.location.href);
      const exactIndex = swipeLinks.findIndex((link) => {
        const target = new URL(link.href, window.location.href);
        return target.origin === current.origin && target.pathname === current.pathname;
      });
      return exactIndex >= 0 ? exactIndex : 0;
    };

    let barSelectedIndex = Math.max(0, barItems.findIndex((item) => item.classList.contains('is-active')));
    let suppressBarClickUntil = 0;

    const closeMobileSearch = () => {
      const searchPopup = document.querySelector('[data-search-popup]');
      const container = searchPopup && searchPopup.querySelector('[data-search-container]');
      if (!searchPopup || !container) return;
      searchPopup.dataset.mobileSearchDesired = 'false';
      container.classList.remove('m-show-search');
      searchPopup.style.setProperty('opacity', '0');
      window.setTimeout(() => {
        searchPopup.style.setProperty('visibility', 'hidden');
        container.style.setProperty('--m-durations', '.3s');
        document.documentElement.classList.remove('prevent-scroll');
        bar.querySelectorAll('[data-open-search-popup]').forEach((trigger) => trigger.removeAttribute('open'));
      }, 350);
    };

    const openMobileSearch = (trigger) => {
      if (typeof trigger.openSearchPopup === 'function') {
        trigger.openSearchPopup();
        return true;
      }

      // Fallback for pages where the theme's custom element is not upgraded.
      const searchPopup = document.querySelector('[data-search-popup]');
      const container = searchPopup && searchPopup.querySelector('[data-search-container]');
      const input = searchPopup && searchPopup.querySelector('[data-search-input]');
      if (!searchPopup || !container) return false;

      searchPopup.dataset.mobileSearchDesired = 'true';
      const applyOpenState = () => {
        if (searchPopup.dataset.mobileSearchDesired !== 'true') return;
        searchPopup.style.removeProperty('visibility');
        searchPopup.style.setProperty('opacity', '1');
        container.classList.add('m-show-search');
        trigger.setAttribute('open', 'true');
        document.documentElement.classList.add('prevent-scroll');
      };
      applyOpenState();
      window.requestAnimationFrame(applyOpenState);
      // Some legacy theme listeners schedule a close during the same tap.
      // Reconcile once after that transition without reopening a user-closed popup.
      window.setTimeout(applyOpenState, 420);
      window.setTimeout(() => {
        container.style.removeProperty('--m-durations');
        if (searchPopup.dataset.mobileSearchDesired === 'true' && input) input.focus({ preventScroll: true });
      }, 450);
      return true;
    };

    const searchPopup = document.querySelector('[data-search-popup]');
    if (searchPopup && searchPopup.dataset.mobileSearchReady !== 'true') {
      searchPopup.dataset.mobileSearchReady = 'true';
      const closeButton = searchPopup.querySelector('[data-close-search]');
      if (closeButton) closeButton.addEventListener('click', closeMobileSearch);
      searchPopup.addEventListener('click', (event) => {
        if (event.target === searchPopup) closeMobileSearch();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && searchPopup.style.visibility !== 'hidden') closeMobileSearch();
      });
    }

    const setBarPill = (index, directX = null) => {
      const item = barItems[index];
      if (!item) return;
      const barRect = bar.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      const x = directX === null ? itemRect.left - barRect.left : directX;
      bar.style.setProperty('--abs-mobile-pill-width', `${itemRect.width}px`);
      bar.style.setProperty('--abs-mobile-pill-x', `${x}px`);
      barItems.forEach((barItem, itemIndex) => barItem.classList.toggle('is-selected', itemIndex === index));
      barSelectedIndex = index;
    };

    const activateBarItem = (index) => {
      const item = barItems[index];
      if (!item) return;

      // The search trigger is itself a custom element. Calling click() after a
      // pointer capture can be swallowed by the bar's click guard on iOS and
      // Android, so invoke the public component method directly when present.
      if (item.matches('[data-open-search-popup]')) {
        suppressBarClickUntil = 0;
        if (openMobileSearch(item)) return;
      }

      const link = item.matches('a[href]') ? item : item.querySelector('a[href]');

      if (link) {
        const destination = new URL(link.href, window.location.href);
        if (destination.href === window.location.href) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }
        try {
          window.sessionStorage.setItem(
            'abs-mobile-nav-direction',
            index >= barSelectedIndex ? 'forward' : 'back'
          );
        } catch (error) {
          // Navigation remains functional when storage is unavailable.
        }
        document.body.classList.add(index >= barSelectedIndex ? 'abs-mobile-page-leaving' : 'abs-mobile-swipe-committing-right');
        window.setTimeout(() => window.location.assign(destination.href), 170);
        return;
      }

            if (item.matches('[data-open-search-popup]')) {
        const searchController = typeof item.openSearchPopup === 'function'
          ? item
          : [...document.querySelectorAll('m-search-popup[data-open-search-popup]')]
              .find((element) => typeof element.openSearchPopup === 'function');

        if (searchController) {
          suppressBarClickUntil = 0;
          searchController.openSearchPopup();
          return;
        }
      }        const searchPopup = document.querySelector('[data-search-popup]');
        const searchContainer = searchPopup?.querySelector('[data-search-container]');
        const searchInput = searchPopup?.querySelector('[data-search-input]');

        if (searchPopup && searchContainer) {
          if (searchPopup.dataset.mobileSearchFallbackReady !== 'true') {
            const closeFallbackSearch = () => {
              searchContainer.classList.remove('m-show-search');
              searchPopup.style.setProperty('opacity', '0');
              window.setTimeout(() => {
                searchPopup.style.setProperty('visibility', 'hidden');
                document.documentElement.classList.remove('prevent-scroll');
                item.removeAttribute('open');
              }, 350);
            };

            searchPopup.querySelector('[data-close-search]')?.addEventListener('click', closeFallbackSearch);
            searchPopup.addEventListener('click', (event) => {
              if (event.target === searchPopup) closeFallbackSearch();
            });
            searchPopup.dataset.mobileSearchFallbackReady = 'true';
          }

          suppressBarClickUntil = 0;
          searchPopup.style.removeProperty('visibility');
          searchPopup.style.setProperty('opacity', '1');
          searchContainer.classList.add('m-show-search');
          item.setAttribute('open', 'true');
          document.documentElement.classList.add('prevent-scroll');
          window.setTimeout(() => searchInput?.focus(), 350);
          return;
        }


const control = item.matches('[data-open-search-popup]')
        ? item
        : item.querySelector('button, [role="button"], [data-open-search-popup]');
      if (control) {
        window.setTimeout(() => {
          suppressBarClickUntil = 0;
          control.click();
        }, 0);
      }
    };

        const mobileSearchItem = bar.querySelector('[data-open-search-popup]');
    if (mobileSearchItem) {
      mobileSearchItem.addEventListener('click', (event) => {
        if (!mobileQuery.matches || Date.now() < suppressBarClickUntil) return;
        event.preventDefault();
        event.stopPropagation();
        const searchIndex = barItems.indexOf(mobileSearchItem);
        if (searchIndex >= 0) activateBarItem(searchIndex);
      });
    }

if (barItems.length) {
      window.requestAnimationFrame(() => setBarPill(barSelectedIndex));
      window.addEventListener('resize', () => setBarPill(barSelectedIndex), { passive: true });

      let barPointerId = null;
      let barStartX = 0;
      let barStartPillX = 0;
      let barCandidateIndex = barSelectedIndex;
      let barPressedIndex = barSelectedIndex;
      let barDragging = false;

      const nearestBarIndex = (clientX) => {
        let nearestIndex = 0;
        let nearestDistance = Infinity;
        barItems.forEach((item, index) => {
          const rect = item.getBoundingClientRect();
          const distance = Math.abs(clientX - (rect.left + rect.width / 2));
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });
        return nearestIndex;
      };

      bar.addEventListener('click', (event) => {
        const eventTarget = event.target instanceof Element ? event.target : event.target.parentElement;
        const searchTrigger = eventTarget && eventTarget.closest('[data-open-search-popup]');
        if (searchTrigger && bar.contains(searchTrigger)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          suppressBarClickUntil = 0;
          openMobileSearch(searchTrigger);
          return;
        }
                const clickTarget = event.target instanceof Element ? event.target : event.target?.parentElement;
                        const searchTarget = clickTarget?.closest('[data-open-search-popup]');
                                if (searchTarget && mobileQuery.matches) {
                                          event.preventDefault();
                                                    event.stopImmediatePropagation();
                                                              suppressBarClickUntil = 0;
                                                                        const searchIndex = barItems.indexOf(searchTarget);
                                                                                  if (searchIndex >= 0) activateBarItem(searchIndex);
                                                                                            return;
                                                                                                    }
                                                                                                    if (Date.now() >= suppressBarClickUntil) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);

      bar.addEventListener('dragstart', (event) => event.preventDefault());

      bar.addEventListener('pointerdown', (event) => {
        if (!mobileQuery.matches || !event.isPrimary) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        event.preventDefault();
        const barRect = bar.getBoundingClientRect();
        const selectedRect = barItems[barSelectedIndex].getBoundingClientRect();
        barPointerId = event.pointerId;
        barStartX = event.clientX;
        barStartPillX = selectedRect.left - barRect.left;
        barPressedIndex = nearestBarIndex(event.clientX);
        barCandidateIndex = barPressedIndex;
        barDragging = false;
        suppressBarClickUntil = Date.now() + 600;
        if (!bar.hasPointerCapture(event.pointerId)) bar.setPointerCapture(event.pointerId);
      }, { passive: false });

      bar.addEventListener('pointermove', (event) => {
        if (event.pointerId !== barPointerId) return;
        const delta = event.clientX - barStartX;
        if (!barDragging && Math.abs(delta) < 5) return;
        barDragging = true;
        event.preventDefault();
        if (!bar.hasPointerCapture(event.pointerId)) bar.setPointerCapture(event.pointerId);
        bar.classList.add('is-dragging');

        const barRect = bar.getBoundingClientRect();
        const selectedWidth = barItems[barSelectedIndex].getBoundingClientRect().width;
        const minX = 0;
        const maxX = Math.max(0, barRect.width - selectedWidth);
        const pillX = Math.max(minX, Math.min(maxX, barStartPillX + delta));
        bar.style.setProperty('--abs-mobile-pill-x', `${pillX}px`);

        barCandidateIndex = nearestBarIndex(event.clientX);
        barItems.forEach((item, index) => item.classList.toggle('is-selected', index === barCandidateIndex));
      }, { passive: false });

      const finishBarDrag = (event) => {
        if (event.pointerId !== barPointerId) return;
        barPointerId = null;
        bar.classList.remove('is-dragging');
        const targetIndex = barDragging ? barCandidateIndex : barPressedIndex;
        barDragging = false;
        suppressBarClickUntil = Date.now() + 450;
        const previousIndex = barSelectedIndex;
        setBarPill(targetIndex);
        barSelectedIndex = previousIndex;
        activateBarItem(targetIndex);
      };

      bar.addEventListener('pointerup', finishBarDrag, { passive: false });
      bar.addEventListener('pointercancel', finishBarDrag, { passive: false });
    }

    const navigateAfterSwipe = (direction) => {
      const index = currentSwipeIndex();
      const targetIndex = direction === 'left' ? index + 1 : index - 1;
      const link = swipeLinks[targetIndex];

      if (!link) return false;

      try {
        window.sessionStorage.setItem(
          'abs-mobile-nav-direction',
          direction === 'left' ? 'forward' : 'back'
        );
      } catch (error) {
        // Navigation remains functional when storage is unavailable.
      }

      document.body.classList.add(
        direction === 'left' ? 'abs-mobile-swipe-committing-left' : 'abs-mobile-swipe-committing-right'
      );
      window.setTimeout(() => window.location.assign(link.href), 170);
      return true;
    };

    if (pageSurface && mobileQuery.matches && !reduceMotionQuery.matches && swipeLinks.length > 1) {
      let startX = 0;
      let startY = 0;
      let deltaX = 0;
      let tracking = false;
      let horizontal = false;
      let pointerId = null;
      let suppressClickUntil = 0;

      const ignoredTarget = (target) => target instanceof Element && Boolean(target.closest(
        'input, textarea, select, [contenteditable="true"], [role="dialog"], [data-swipe-ignore], .swiper, .swiper-wrapper, .splide, .flickity-enabled, [data-slider]'
      ));

      pageSurface.addEventListener('click', (event) => {
        if (Date.now() >= suppressClickUntil) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);

      pageSurface.style.touchAction = 'pan-y pinch-zoom';

      pageSurface.addEventListener('pointerdown', (event) => {
        if (!event.isPrimary || ignoredTarget(event.target)) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        startX = event.clientX;
        startY = event.clientY;
        deltaX = 0;
        tracking = true;
        horizontal = false;
        pointerId = event.pointerId;
      }, { passive: true });

      pageSurface.addEventListener('pointermove', (event) => {
        if (!tracking || event.pointerId !== pointerId) return;
        deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;

        if (!horizontal) {
          if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > 10) {
            tracking = false;
            return;
          }
          if (Math.abs(deltaX) < 10) return;
          horizontal = Math.abs(deltaX) > Math.abs(deltaY) * 1.15;
        }

        if (!horizontal) return;
        event.preventDefault();
        if (!pageSurface.hasPointerCapture(event.pointerId)) {
          pageSurface.setPointerCapture(event.pointerId);
        }
        const resistedDelta = Math.max(-96, Math.min(96, deltaX * .48));
        document.body.classList.add('abs-mobile-swipe-dragging');
        document.documentElement.style.setProperty('--abs-mobile-swipe-x', `${resistedDelta}px`);
      }, { passive: false });

      const finishSwipe = (event) => {
        if (event.pointerId !== pointerId) return;
        if (!tracking && !horizontal) return;
        const threshold = Math.min(82, window.innerWidth * .2);
        const direction = deltaX < 0 ? 'left' : 'right';
        const shouldNavigate = horizontal && Math.abs(deltaX) >= threshold;

        if (horizontal && Math.abs(deltaX) > 12) suppressClickUntil = Date.now() + 450;

        tracking = false;
        horizontal = false;
        pointerId = null;
        document.body.classList.remove('abs-mobile-swipe-dragging');
        document.documentElement.style.removeProperty('--abs-mobile-swipe-x');

        if (shouldNavigate && navigateAfterSwipe(direction)) return;
        document.body.classList.add('abs-mobile-swipe-cancelled');
        window.setTimeout(() => document.body.classList.remove('abs-mobile-swipe-cancelled'), 240);
      };

      pageSurface.addEventListener('pointerup', finishSwipe, { passive: true });
      pageSurface.addEventListener('pointercancel', finishSwipe, { passive: true });
    }

    bar.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : event.target.parentElement;
      const link = target && target.closest('a[href]');
      if (!link || !mobileQuery.matches) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (link.target && link.target !== '_self') return;

      let destination;
      try {
        destination = new URL(link.href, window.location.href);
      } catch (error) {
        return;
      }

      if (destination.origin !== window.location.origin || destination.hash) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (destination.pathname === window.location.pathname && destination.search === window.location.search) {
        window.scrollTo({ top: 0, behavior: reduceMotionQuery.matches ? 'auto' : 'smooth' });
        return;
      }

      try {
        window.sessionStorage.setItem('abs-mobile-nav-direction', 'forward');
      } catch (error) {
        // Navigation remains functional when storage is unavailable.
      }

      if (reduceMotionQuery.matches) {
        window.location.assign(destination.href);
        return;
      }

      document.body.classList.add('abs-mobile-page-leaving');
      window.setTimeout(() => window.location.assign(destination.href), 190);
    }, true);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMobileNavigation, { once: true });
  } else {
    initializeMobileNavigation();
  }
})();
